export const environment = {
  production: false,
  name: 'dev',
  apiUrl2: 'https://api-connect.dev.docestate.com',
  mapUrl: 'https://maps.apps.dev.docestate.com',
  realm: "DocEstateDev",
  userInfoEndpoint: "https://authentication.dev.docestate.com/realms/DocEstateDev/protocol/openid-connect/userinfo",
  tokenEndpoint: 'https://authentication.dev.docestate.com/realms/DocEstateDev/protocol/openid-connect/token',
  loginUrl: 'https://authentication.dev.docestate.com/realms/DocEstateDev/protocol/openid-connect/auth',
  logoutUrl: 'https://authentication.dev.docestate.com/realms/DocEstateDev/protocol/openid-connect/logout',
  issuer:'https://authentication.dev.docestate.com/realms/DocEstateDev',
  clientId: 'CONNECTFRONTEND'
};
